import React from "react";
import {useNavigate} from "react-router-dom";
import {Heading} from "../../../components";
import {Img} from "../../../components";
import {useTranslation} from "react-i18next"

interface Props {
    className?: string;
}

export default function Footer({...props}: Props) {

    function getYear() {
        return new Date().getFullYear();
    }

    const currentYear = getYear()

    const navigate = useNavigate();

    const {t} = useTranslation();

    const handleSmoothScroll = (
        event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
        targetId: string
    ) => {
        event.preventDefault();

        if (window.location.pathname === "/landing") {
            const targetElement = document.getElementById(targetId);
            if (targetElement) {
                targetElement.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                });
            }
        } else {
            navigate("/landing", {state: {targetId}});
        }
    };


    return (
        <>
            <footer
                {...props}
                className={`${props.className} md:hidden sm:hidden bg-[#333333] rounded-tr-[80px] rounded-tl-[80px] flex items-center justify-center py-10 sm:py-4`}
            >
                <div className="container-xs flex justify-center px-6">
                    <div className=" flex w-full flex-col gap-20 ">
                        <div className="sm:gap-[38px] md:gap-[57px] lg:gap-[76px] gap-[76px] flex flex-col">
                            <div className=" flex flex-col items-start gap-10">
                                <div className=" flex items-start w-full">
                                    <a href="/landing">
                                        <Img
                                            src="/images/hyperionixLogoFooter.svg"
                                            alt="Footer Logo"
                                            className="w-full h-[24px] object-contain"
                                        />
                                    </a>
                                    <div className="flex ml-[476px] justify-end py-1.5">
                                        <div className="flex w-full flex-wrap justify-between gap-5">
                                            <Heading
                                                size="desktop_heading_6"
                                                as="p"
                                                className="ml-[30px] font-medium uppercase text-[#E9E9E9] w-[333px]">
                                                Hyper-consult@mail.ru
                                            </Heading>
                                            <Heading
                                                size="desktop_heading_6"
                                                as="p"
                                                className="font-medium text-[#E9E9E9]">
                                                <a href="tel:+74955427541">
                                                    +7(495)542-75-41
                                                </a>
                                            </Heading>
                                        </div>
                                    </div>
                                </div>
                                <div className="h-px w-full self-stretch bg-[#B0B0B0]"/>
                            </div>
                            <div className="flex w-full items-center justify-between gap-5">
                                <div className="flex w-[333px] flex-col items-start gap-[28px]">
                                    <Heading
                                        size="desktop_heading_6"
                                        className="font-medium uppercase text-[#FFFFFFB8]">
                                        {t("footer.subscribe")}
                                    </Heading>
                                    <input name="email" placeholder={`Email`}
                                           className="h-[56px] w-[261px] self-stretch rounded-[12px] px-4 bg-[#ffffff28] shadow-[0_2px_3px_0_#00000019]"/>
                                </div>
                                <div className="flex items-center gap-5">
                                    <ul className="fleч w-[329px] flex-col items-start gap-3">
                                        <li>
                                            <a href="#Cover" target="_blank" rel="noreferrer"
                                               onClick={(e) => handleSmoothScroll(e, "Cover")}>
                                                <Heading
                                                    size="desktop_body_l"
                                                    as="p"
                                                    className=" !text-[#FFFFFF]">
                                                    {t("footer.column_1.1")}
                                                </Heading>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#Feature" target="_blank" rel="noreferrer"
                                               onClick={(e) => handleSmoothScroll(e, "Feature")}>
                                                <Heading
                                                    size="desktop_body_l"
                                                    as="p"
                                                    className=" !text-[#FFFFFF] mt-3">
                                                    {t("footer.column_1.2")}
                                                </Heading>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#OurPlus" target="_blank" rel="noreferrer"
                                               onClick={(e) => handleSmoothScroll(e, "OurPlus")}>
                                                <Heading
                                                    size="desktop_body_l"
                                                    as="p"
                                                    className=" !text-[#FFFFFF] mt-3">
                                                    {t("footer.column_1.3")}
                                                </Heading>
                                            </a>
                                        </li>
                                    </ul>
                                    <ul className="w-[333px] flex flex-col items-start self-start md:w-full ">
                                        <li>
                                            <a href="#WhyUs" target="_blank" rel="noreferrer"
                                               onClick={(e) => handleSmoothScroll(e, "WhyUs")}>
                                                <Heading
                                                    size="desktop_body_l"
                                                    as="p"
                                                    className=" !text-[#FFFFFF]">
                                                    {t("footer.column_2.1")}
                                                </Heading>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#activation" target="_blank" rel="noreferrer"
                                               onClick={(e) => handleSmoothScroll(e, "activation")}>
                                                <Heading
                                                    size="desktop_body_l"
                                                    as="p"
                                                    className=" !text-[#FFFFFF] mt-3">
                                                    {t("footer.column_2.2")}
                                                </Heading>
                                            </a>
                                        </li>
                                    </ul>
                                    <ul className="fleч w-[333px] flex-col items-start">
                                        <li>
                                            <a href="#Case" target="_blank" rel="noreferrer"
                                               onClick={(e) => handleSmoothScroll(e, "Case")}>
                                                <Heading
                                                    size="desktop_body_l"
                                                    as="p"
                                                    className=" !text-[#FFFFFF]">
                                                    {t("footer.column_3.1")}
                                                </Heading>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#pricing" target="_blank" rel="noreferrer"
                                               onClick={(e) => handleSmoothScroll(e, "pricing")}>
                                                <Heading
                                                    size="desktop_body_l"
                                                    as="p"
                                                    className=" !text-[#FFFFFF] mt-3">
                                                    {t("footer.column_3.2")}
                                                </Heading>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#FAQ" target="_blank" rel="noreferrer"
                                               onClick={(e) => handleSmoothScroll(e, "FAQ")}>
                                                <Heading
                                                    size="desktop_body_l"
                                                    as="p"
                                                    className=" !text-[#FFFFFF] mt-3">
                                                    {t("footer.column_3.3")}
                                                </Heading>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-col gap-[38px]">
                            <div className="h-px bg-[#B0B0B0]"/>
                            <div className="flex gap-5">
                                <Heading
                                    size="desktop_body_s_bold"
                                    className="text-[#FFFFFFB8] w-[47.6%]">
                                    © {currentYear} {t("footer.reserved")}
                                </Heading>
                                <Heading
                                    size="desktop_body_s_bold"
                                    className="text-[#FFFFFFB8] w-[47.6%]">
                                    {t("footer.address")}
                                </Heading>
                                <div className="flex  flex-row gap-5">
                                    <Heading
                                        size="desktop_body_s_bold"
                                        className="text-[#FFFFFFB8] w-[333px] ml-[32px]">
                                        <a href={`/docs/${t("docsPrivacy")}`} target="_blank">
                                            {t("footer.privacy")}
                                        </a>
                                    </Heading>
                                    <Heading
                                        size="desktop_body_s_bold"
                                        className="text-[#FFFFFFB8] w-[333px]">
                                        <a href={`/docs/${t("docsOffer")}`} target="_blank">
                                            {t("footer.offer")}
                                        </a>
                                    </Heading>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
            <footer>


                {/* MD-only Footer */}
                <div className=" md:block lg:hidden bg-[#333333] rounded-tr-[48px] rounded-tl-[48px] py-10">
                    <div className="container-xs px-5">
                        <div className=" grid w-full gap-4">
                            <a href="/landing" className="grid grid-cols-2 justify-self-start">
                                <Img
                                    src="/images/hyperionixLogoFooter.svg"
                                    alt="Footer Logo"
                                    className="w-full h-[24px] object-contain"
                                />
                            </a>
                            <div className="grid grid-rows-1 py-1.5 sm:grid-rows-1">
                                <div className="grid grid-cols-2 w-full gap-2 sm:grid-cols-1">
                                    <Heading
                                        size="desktop_heading_6"
                                        as="p"
                                        className=" font-medium uppercase text-[#E9E9E9]">
                                        Hyper-consult@mail.ru
                                    </Heading>
                                    <Heading
                                        size="desktop_heading_6"
                                        as="p"
                                        className="font-medium text-[#E9E9E9] text-left">
                                        <a href="tel:+74955427541">
                                            +7(495)542-75-41
                                        </a>
                                    </Heading>
                                </div>
                            </div>
                        </div>
                        <div className="h-px w-full self-stretch bg-[#B0B0B0]  md:mt-4 sm:mt-4"/>
                        <div className="w-full grid grid-cols-2 grid-rows-2 gap-[8px] gap-y-[30px] my-[30px] sm:my-5">

                            {/* 1-й квадрант: О компании, Возможности, Услуги */}
                            <ul className="flex flex-col items-start gap-3 col-start-1 row-start-1">
                                <li>
                                    <a href="#Cover" onClick={e => handleSmoothScroll(e, "Cover")}>
                                        <Heading size="desktop_body_l" as="p" className="!text-[#FFFFFF]">
                                            {t("footer.column_1.1")}
                                        </Heading>
                                    </a>
                                </li>
                                <li>
                                    <a href="#Feature" onClick={e => handleSmoothScroll(e, "Feature")}>
                                        <Heading size="desktop_body_l" as="p" className="!text-[#FFFFFF] ">
                                            {t("footer.column_1.2")}
                                        </Heading>
                                    </a>
                                </li>
                                <li>
                                    <a href="#OurPlus" onClick={e => handleSmoothScroll(e, "OurPlus")}>
                                        <Heading size="desktop_body_l" as="p" className="!text-[#FFFFFF] ">
                                            {t("footer.column_1.3")}
                                        </Heading>
                                    </a>
                                </li>
                            </ul>

                            {/* 2-й квадрант: Кастомизация, Как работает */}
                            <ul className="flex flex-col items-start gap-3 col-start-2 row-start-1">
                                <li>
                                    <a href="#WhyUs" onClick={e => handleSmoothScroll(e, "WhyUs")}>
                                        <Heading size="desktop_body_l" as="p" className="!text-[#FFFFFF]">
                                            {t("footer.column_2.1")}
                                        </Heading>
                                    </a>
                                </li>
                                <li>
                                    <a href="#activation" onClick={e => handleSmoothScroll(e, "activation")}>
                                        <Heading size="desktop_body_l" as="p" className="!text-[#FFFFFF] ">
                                            {t("footer.column_2.2")}
                                        </Heading>
                                    </a>
                                </li>
                            </ul>

                            {/* 3-й квадрант (лево-низ): Подписка */}
                            <div
                                className="flex flex-col items-start gap-[28px] col-start-1 row-start-2 sm:row-start-3">
                                <Heading size="desktop_heading_6"
                                         className="font-medium uppercase text-[#FFFFFFB8] sm:whitespace-nowrap">
                                    {t("footer.subscribe")}
                                </Heading>
                                <input
                                    name="email"
                                    placeholder="Email"
                                    className="h-[56px] w-[261px] sm:w-[343px] rounded-[12px] px-4 bg-[#ffffff28] shadow-[0_2px_3px_0_#00000019]"
                                />
                            </div>

                            {/* 4-й квадрант: Кейсы, Тарифы, FAQ */}
                            <ul className="flex flex-col items-start gap-3 col-start-2 row-start-2 sm:col-start-1">
                                <li>
                                    <a href="#Case" onClick={e => handleSmoothScroll(e, "Case")}>
                                        <Heading size="desktop_body_l" as="p" className="!text-[#FFFFFF]">
                                            {t("footer.column_3.1")}
                                        </Heading>
                                    </a>
                                </li>
                                <li>
                                    <a href="#pricing" onClick={e => handleSmoothScroll(e, "pricing")}>
                                        <Heading size="desktop_body_l" as="p" className="!text-[#FFFFFF] ">
                                            {t("footer.column_3.2")}
                                        </Heading>
                                    </a>
                                </li>
                                <li>
                                    <a href="#FAQ" onClick={e => handleSmoothScroll(e, "FAQ")}>
                                        <Heading size="desktop_body_l" as="p" className="!text-[#FFFFFF]">
                                            {t("footer.column_3.3")}
                                        </Heading>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className="flex flex-col gap-[38px]">
                            <div className="h-px bg-[#B0B0B0]"/>
                            <div className="flex sm:flex-col">
                                <Heading
                                    size="desktop_body_s_bold"
                                    className="text-[#FFFFFFB8] w-auto whitespace-nowrap"
                                >
                                    © {currentYear} {t("footer.reserved")}
                                </Heading>
                                <Heading
                                    size="desktop_body_s_bold"
                                    className="text-[#FFFFFFB8] w-auto whitespace-nowrap"
                                >
                                    {t("footer.address")}
                                </Heading>
                                <div className="flex flex-row gap-10 sm:gap-auto sm:mt-2">
                                    <Heading
                                        size="desktop_body_s_bold"
                                        className="text-[#FFFFFFB8] ml-[120px] sm:ml-0"
                                    >

                                        <a href={`/docs/${t("docsPrivacy")}`} target="_blank">
                                            {t("footer.privacy")}
                                        </a>
                                    </Heading>
                                    <Heading
                                        size="desktop_body_s_bold"
                                        className="text-[#FFFFFFB8] whitespace-nowrap"
                                    >
                                        <a href={`/docs/${t("docsOffer")}`} target="_blank">
                                            {t("footer.offer")}
                                        </a>
                                    </Heading>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </footer>
        </>
    );
}
